const Llegenda = ({ mitjana, textos }) => {
	return (
		<>
			<svg
				xmlns='http://www.w3.org/2000/svg'
				width='6'
				height='20'
				viewBox='0 0 6 20'
				fill='none'
				className='mb-5'
			>
				<path
					d='M3 0L0.113249 5L5.88675 5L3 0ZM2.5 4.5L2.5 20L3.5 20L3.5 4.5L2.5 4.5Z'
					fill='black'
				/>
			</svg>
			{textos.mediana}: {mitjana}€
			<span className='e6 text-gris'>{textos.percentil}: 50</span>
		</>
	)
}
export default Llegenda
